import {
   ComponentRef,
   ComponentFactoryResolver,
   ViewContainerRef,
   ViewChild,
   Component,
   Output, EventEmitter
} from '@angular/core';
import {CommentsComponent} from '../comments/comments.component';

@Component({
  selector: 'app-commentbox',
  templateUrl: './commentbox.component.html',
  styleUrls: ['./commentbox.component.css']
})
export class CommentboxComponent {
   @Output() clickDelete = new EventEmitter<any>();
   @Output() selectDrawComment = new EventEmitter<any>();
   @Output() saveCommentTask = new EventEmitter<any>();
   @Output() saveReplyTask = new EventEmitter<any>();
   @Output() deleteCommentTask = new EventEmitter<any>();
   @ViewChild('viewContainerRef', { read: ViewContainerRef })
   viewContainerRef: ViewContainerRef;

   componentsReferences = Array<ComponentRef<CommentsComponent>>();

   constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

   clearCommentComponent() {
      if (this.componentsReferences) {
         this.viewContainerRef.clear();
         this.componentsReferences = Array<ComponentRef<CommentsComponent>>();
      }
   }

   createComponent(item: any, id: string, y: any, isHideAction) {
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(CommentsComponent);

      const commentsComponentRef = this.viewContainerRef.createComponent(componentFactory);

      const commentsComponent = commentsComponentRef.instance;
      commentsComponent.unique_key = id;
      commentsComponent.coordinateY = y;
      commentsComponent.signItems = item;
      commentsComponent.commentBoxRef = this;
      commentsComponent.isHideAction = isHideAction;
      commentsComponent.isHideDeleteBtn = true;
      commentsComponent.clickDelete.subscribe($event => {
         this.onClickDelete($event);
      });
      commentsComponent.selectDrawComment.subscribe($event => {
         this.onSelectDrawComment($event);
      });
      commentsComponent.saveCommentTask.subscribe($event => {
         this.onSaveCommentTask($event);
      });
      commentsComponent.saveReplyTask.subscribe($event => {
         this.onSaveReplyTask($event);
      });
      /** add reference for newly created component */
      this.componentsReferences.push(commentsComponentRef);
   }

   onClickDelete($event: PopStateEvent) {
      this.clickDelete.emit($event);
   }

   onSelectDrawComment ($event: PopStateEvent) {
      this.selectDrawComment.emit($event);
   }

   onSaveCommentTask ($event: PopStateEvent) {
      this.saveCommentTask.emit($event);
   }

   onSaveReplyTask ($event: PopStateEvent) {
      this.saveReplyTask.emit($event);
   }

   remove(id: string) {
      const componentRef = this.onCheckComponentRef(id);
      if (!componentRef) { return; }
      const vcrIndex: number = this.viewContainerRef.indexOf(componentRef.hostView);
      /** removing component from container */
      this.viewContainerRef.remove(vcrIndex);

      /** removing component from the list */
      this.componentsReferences = this.componentsReferences.filter(
         x => x.instance.unique_key !== id
      );
   }

   setSelectComment(id: string, isShow: boolean, isHideDelete) {
      const componentRef = this.onCheckComponentRef(id);
      if (!componentRef) { return; }
      componentRef.instance.onSelectComment(isShow);
      componentRef.instance.isHideDeleteBtn = isHideDelete;
   }

   setPosition(id: string, y: any) {
      const componentRef = this.onCheckComponentRef(id);
      if (!componentRef) { return; }
      componentRef.instance.updatePosition(y);
   }

   onCheckComponentRef(id) {
      if (this.viewContainerRef.length < 1) { return; }
      const found = this.componentsReferences.find(
         x => x.instance.unique_key === id
      );

      if (!found) { return; }
      const componentRef = this.componentsReferences.filter(
         x => x.instance.unique_key === id
      )[0];
      if (!componentRef.instance) { return; }

      return componentRef;
   }

   setDeselectComment(isShow: boolean) {
      if (this.viewContainerRef.length < 1) { return; }
      this.componentsReferences.forEach(componentRef => {
         componentRef.instance.onSelectComment(isShow);
         componentRef.instance.isHideDeleteBtn = true;
      });
   }
}
